import get from 'lodash.get';
import dateOrderValidation from './dateOrderValidation';

// Check that the date in the input value comes after the date in the specified fieldPath
const isAfterDateInField = fieldPath => (value, allValues) => {
	const valueInFieldPath = get(allValues, fieldPath);
	return dateOrderValidation(valueInFieldPath, value);
};

export default isAfterDateInField;
